exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".emailRenderer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.gjs{margin-top:20px;height:calc(100vh - 260px) !important}.gjs__container{display:grid}.gjs__overlay{z-index:5;background-color:rgba(0,0,0,.4);color:#fff;font-weight:strong;font-size:26px;padding-top:50px;text-align:center}.gjs__content,.gjs__overlay{grid-area:1/1}.dev{background:red;padding:10px}.dev__label{color:#fff;text-transform:uppercase}", ""]);

// exports
